import ContactForm from "../forms/ContactForm";
import { MyTypo } from "../../utils/typography/typographier";

function CardMobile8() {
  return (
    <div className="cardOctonary">
      <div className="cardOctonary-containerContains">
        <div className="cardOctonary-containerContains-titles">
          <h2>{MyTypo("Envie d’aller plus loin?")}</h2>
          <p>{MyTypo("Envoyez-nous vos coordonnées et nous vous recontacterons.")}</p>
        </div>
        <div className="cardOctonary-containerContains-contactForms">
          <ContactForm />
        </div>
      </div>
    </div>
  );
}

export default CardMobile8;
